module.exports = __webpack_public_path__ + "static/stageSet10-60957db98137a3fd8fd52541bbf2ddcd.jpg";